import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["skillSelect"];

  confirmSubmit(event) {
    const select = this.skillSelectTarget;
    if (!select.value) {
      event.preventDefault();
      window.alert("Please select a skill.");
      return;
    }

    const label = select.options[select.selectedIndex].text;
    let message;
    if (select.value === "all") {
      message =
        "Are you sure you want to create ratings and competency checks for all users and all skills on this event?";
    } else {
      message = `Are you sure you want to create ratings and competency checks for all users on "${label}"?`;
    }

    if (!window.confirm(message)) {
      event.preventDefault();
    }
  }
}
